<template>
  <div class="page-view"><sfgta-agreement /></div>
</template>

<script>
import sfgtaAgreement from "@/mycfm/components/new-company/SfgtaAgreement";
export default {
  components: {
    sfgtaAgreement
  }
};
</script>
